module.exports = __webpack_public_path__ + "img/p3-p1-bg.d6bb6f76.jpg";